import ModalReviewPresentation from './ModalReviewPresentation.vue'

const REVIEW_PRESENTATIONS = Object.freeze({
    modal: ModalReviewPresentation,
})

const resolveReviewPresentation = name => REVIEW_PRESENTATIONS[name] || null

export { resolveReviewPresentation }
